import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=2cc34217"
import script from "./SignUpModal.vue?vue&type=script&lang=ts"
export * from "./SignUpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports